document.addEventListener("DOMContentLoaded", function() {
  const initializeChargebeeProductTracking = (dropInLinkId, planName, content_ids, coupon_id) => {
    const cbInstance = Chargebee.getInstance();

    if (!cbInstance) {
      return;
    }

    const checkoutElement = document.getElementById(dropInLinkId);
    const product = cbInstance.getProduct(checkoutElement);

    product.data["cf_Device_IMEI"] = "pending";
    product.data["cf_SIM_ID_ICCID"] = "pending";

    if (coupon_id) product.addCoupon(coupon_id);

    checkoutElement.addEventListener('click', function() {
      if (typeof fbq !== 'undefined') {
        fbq('track', 'ViewContent', {
          content_name: planName,
          content_category: 'Subscription',
          content_ids: content_ids,
          content_type: 'product'
        });

        fbq('track', 'TEST47985', {
          content_name: planName,
          content_category: 'Subscription',
          content_ids: content_ids,
          content_type: 'product'
        });
      }
    });

    cbInstance.setCheckoutCallbacks({
      loaded: function() {
        if (typeof fbq !== 'undefined') {
          fbq('track', 'InitiateCheckout', {
            content_category: 'Subscription',
            content_ids: [content_ids[0]],
            num_items: 3
          });
        }
      },
      close: function() {
      },
      success: function(hostedPageId) {
        if (typeof fbq !== 'undefined') {
          fbq('track', 'Purchase', {
            content_type: 'product',
            content_ids: [content_ids[0]],
            num_items: 3,
            currency: 'USD'
          });
        }
      },
      step: function(step) {
        if (typeof fbq !== 'undefined') {
          switch(step) {
            case 'customer_info':
            case 'login_initiated':
              fbq('trackCustom', 'CheckoutStep_CustomerInfo');
              break;
            case 'shipping_address':
              fbq('trackCustom', 'CheckoutStep_ShippingAddress');
              break;
            case 'payment_initiated':
              fbq('track', 'AddToCart', {
                  content_ids: [content_ids[0]],
                  content_type: 'product',
                  num_items: 3
              });
              break;
            case 'payment_method':
              fbq('track', 'AddPaymentInfo', {
                  content_category: 'Subscription'
              });
              break;
            case 'order_summary':
            case 'review':
              fbq('trackCustom', 'CheckoutStep_Review');
              break;
            default:
              fbq('trackCustom', step);
          }
        }
      }
    });
  }

  initializeChargebeeProductTracking('cb-residential-standard-cc', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], null)
  initializeChargebeeProductTracking('cb-residential-advanced-cc', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], null)
  initializeChargebeeProductTracking('cb-travel-standard-cc', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], null)
  initializeChargebeeProductTracking('cb-travel-advanced-cc', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], null)
  initializeChargebeeProductTracking('cb-residential-standard-with-coupon', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'Oklahoma')
  initializeChargebeeProductTracking('cb-residential-advanced-with-coupon', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'Oklahoma')
  initializeChargebeeProductTracking('cb-travel-standard-with-coupon', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'Oklahoma')
  initializeChargebeeProductTracking('cb-travel-advanced-with-coupon', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'Oklahoma')
  initializeChargebeeProductTracking('cb-residential-standard-with-coupon-15', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'CONNECT15')
  initializeChargebeeProductTracking('cb-residential-advanced-with-coupon-15', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'CONNECT15')
  initializeChargebeeProductTracking('cb-travel-standard-with-coupon-15', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'CONNECT15')
  initializeChargebeeProductTracking('cb-travel-advanced-with-coupon-15', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'CONNECT15')

  const data = {
    useLocation: null,
    homeUse: [],
    roadUse: null,
    firstName: null,
    lastName: null,
    address: null,
    email: null,
    phoneNumber: null,
    discounted: false,
  };

  const coverageCheckerPopup2Main = document.getElementById('quiz-popup-main');
  const coverageCheckerPopup2MainCloseButton = document.getElementById('quiz-popup-main-close-button');
  const coverageCheckerPopup2MainTriggers = document.querySelectorAll('.quiz-popup-trigger');

  coverageCheckerPopup2MainCloseButton.addEventListener('click', hideCoverageCheckerPopup2Container)
  coverageCheckerPopup2Main.addEventListener('click', (e) => e.stopPropagation());

  coverageCheckerPopup2MainTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      showCoverageCheckerPopup2Container(data);
      openCoverageCheckerPopup2Main(data);
      showCoverageCheckerPopup2MainStep1(data);
    });
  });

  const coverageCheckerPopup2Container = document.getElementById('quiz-popup-container');

  coverageCheckerPopup2Container.addEventListener('click', hideCoverageCheckerPopup2Container);

  const VERSION = 'v1';
  const KEY = `coveragePopupLastShown_${VERSION}`;

  if (window.location.pathname == '/pages/plans') return;

  if (window.innerWidth > 650) {
    window.addEventListener('mouseout', (e) => {
      if (e.toElement == null && e.relatedTarget == null) {
        if (data.popupOpen) return;

        const now = Date.now();
        const last = parseInt(localStorage.getItem(KEY), 10);

        if (!last || now - last > 1 * 60 * 60 * 1000) {
          showCoverageCheckerPopup2Container(data);
          openCoverageCheckerPopup2Main(data);
          showCoverageCheckerPopup2MainStep1(data);
        }
      }
    });
  } else {
    setTimeout(() => {
      const now = Date.now();
      const last = parseInt(localStorage.getItem(KEY), 10);

      if (!last || now - last > 1 * 60 * 60 * 1000) {
        showCoverageCheckerPopup2Container(data);
        openCoverageCheckerPopup2Main(data);
        showCoverageCheckerPopup2MainStep1(data);
        localStorage.setItem(KEY, now);
      }
    }, 15 * 1000);
  }
});

const showCoverageCheckerPopup2Container = (d) => {
  d.popupOpen = true;
  const coverageCheckerPopup2Container = document.getElementById('quiz-popup-container');
  coverageCheckerPopup2Container.style.display = 'flex';
}

const hideCoverageCheckerPopup2Container = (d) => {
  d.popupOpen = false;
  const coverageCheckerPopup2Container = document.getElementById('quiz-popup-container');
  coverageCheckerPopup2Container.style.display = 'none';

  const KEY = `coveragePopupLastShown_${VERSION}`;
  const now = Date.now();
  localStorage.setItem(KEY, now);
}

const openCoverageCheckerPopup2Main = () => {
  const coverageCheckerPopup2Main = document.getElementById('quiz-popup-main');
  const coverageCheckerPopup2MainError = document.getElementById('quiz-popup-main-error');
  const coverageCheckerPopup2MainErrorMessage = document.getElementById('quiz-popup-main-error-message');

  coverageCheckerPopup2MainError.style.display = 'none';
  coverageCheckerPopup2MainErrorMessage.innerText = 'An error occurred';
  coverageCheckerPopup2Main.style.display = 'flex';
}

const closeCoverageCheckerPopup2Main = (data) => {
  const coverageCheckerPopup2Main = document.getElementById('quiz-popup-main');
  coverageCheckerPopup2Main.style.display = 'none';
  hideCoverageCheckerPopup2Container(data);
}

const showCoverageCheckerPopup2MainStep1 = (data) => {
  const coverageCheckerPopup2MainStep1 = document.getElementById('quiz-popup-main-step-1');
  const coverageCheckerPopup2MainStep2Road = document.getElementById('quiz-popup-main-step-2-road');
  const coverageCheckerPopup2MainStep2Home = document.getElementById('quiz-popup-main-step-2-home');
  const coverageCheckerPopup2MainStep3 = document.getElementById('quiz-popup-main-step-3');
  const coverageCheckerPopup2MainStep4 = document.getElementById('quiz-popup-main-step-4');
  const coverageCheckerPopup2MainStep5 = document.getElementById('quiz-popup-main-step-5');

  coverageCheckerPopup2MainStep5.style.display = 'none';
  coverageCheckerPopup2MainStep4.style.display = 'none';
  coverageCheckerPopup2MainStep3.style.display = 'none';
  coverageCheckerPopup2MainStep2Road.style.display = 'none';
  coverageCheckerPopup2MainStep2Home.style.display = 'none';
  coverageCheckerPopup2MainStep1.style.display = 'flex';

  const quizPopupBackButton = document.getElementById('quiz-popup-main-back-button');
  quizPopupBackButton.style.display = 'none';

  const coverageCheckerPopupProgressBarStep1 = document.getElementById('quiz-popup-main-progress-bar-fill-1');
  const coverageCheckerPopupProgressBarStep2 = document.getElementById('quiz-popup-main-progress-bar-fill-2');
  const coverageCheckerPopupProgressBarStep3 = document.getElementById('quiz-popup-main-progress-bar-fill-3');
  const coverageCheckerPopupProgressBarStep4 = document.getElementById('quiz-popup-main-progress-bar-fill-4');

  coverageCheckerPopupProgressBarStep1.style.width = '0%';
  coverageCheckerPopupProgressBarStep2.style.width = '0%';
  coverageCheckerPopupProgressBarStep3.style.width = '0%';
  coverageCheckerPopupProgressBarStep4.style.width = '0%';

  const coverageCheckerPopup2MainProgressText = document.getElementById('quiz-popup-main-progress-text');
  coverageCheckerPopup2MainProgressText.innerText = 'Step 1 of 4';

  const coverageCheckerPopupMainHeading1 = document.getElementById('quiz-popup-main-heading-1');
  const coverageCheckerPopupMainHeading2 = document.getElementById('quiz-popup-main-heading-2');
  const coverageCheckerPopupMainheading3 = document.getElementById('quiz-popup-main-heading-3');
  const coverageCheckerPopupMainheading4 = document.getElementById('quiz-popup-main-heading-4');
  const coverageCheckerPopupMainheading5 = document.getElementById('quiz-popup-main-heading-5');
  const coverageCheckerPopupMainheading6 = document.getElementById('quiz-popup-main-heading-6');

  coverageCheckerPopupMainHeading1.style.display = 'flex';
  coverageCheckerPopupMainHeading2.style.display = 'none';
  coverageCheckerPopupMainheading3.style.display = 'none';
  coverageCheckerPopupMainheading4.style.display = 'none';
  coverageCheckerPopupMainheading5.style.display = 'none';
  coverageCheckerPopupMainheading6.style.display = 'none';

  const coverageCheckerPopup2MainStep1FormOptions = document.getElementById('quiz-popup-main-step-1-form-content-options');
  const coverageCheckerPopup2MainStep1Buttons = coverageCheckerPopup2MainStep1FormOptions.querySelectorAll('button');
  const coverageCheckerPopup2MainStep1Submit = document.getElementById('quiz-popup-main-step-1-submit');

  const coverageCheckerPopup2MainStep1ButtonEventHandler = (e) => {
    if (data.useLocation == e.currentTarget.dataset.useLocation) {
    } else {
      data.useLocation = e.currentTarget.dataset.useLocation;

      coverageCheckerPopup2MainStep1Buttons.forEach((button) => {
        button.classList.remove('quiz-popup-main-form-content-button-selected');
      })

      e.currentTarget.classList.add('quiz-popup-main-form-content-button-selected');
      coverageCheckerPopup2MainStep1Submit.disabled = false;
    }

    coverageCheckerPopup2MainStep1Submit.scrollIntoView({ block: 'center', behavior: 'smooth' })
  }

  const coverageCheckerPopup2MainStep1SubmitEventHandler = (e) => {
    e.preventDefault();

    coverageCheckerPopup2MainStep1Buttons.forEach((button, i) => {
      button.removeEventListener('click', coverageCheckerPopup2MainStep1ButtonEventHandler, true);
    });
    coverageCheckerPopup2MainStep1Submit.removeEventListener('click', coverageCheckerPopup2MainStep1SubmitEventHandler, true);

    if (data.useLocation == 'home') {
      showCoverageCheckerPopup2MainStep2Home(data);
    } else {
      showCoverageCheckerPopup2MainStep2Road(data);
    }
  }

  coverageCheckerPopup2MainStep1Buttons.forEach((button) => {
    button.addEventListener('click', coverageCheckerPopup2MainStep1ButtonEventHandler, true);
  });
  coverageCheckerPopup2MainStep1Submit.addEventListener('click', coverageCheckerPopup2MainStep1SubmitEventHandler, true);

  if (data.useLocation != null) {
    coverageCheckerPopup2MainStep1Buttons.forEach((button) => {
      if (data.useLocation == button.dataset.useLocation) {
        button.classList.add('quiz-popup-main-form-content-button-selected');
        coverageCheckerPopup2MainStep1Submit.disabled = false;
      }
    });
  }
}

const showCoverageCheckerPopup2MainStep3 = (data) => {
  const coverageCheckerPopup2MainStep1 = document.getElementById('quiz-popup-main-step-1');
  const coverageCheckerPopup2MainStep2Road = document.getElementById('quiz-popup-main-step-2-road');
  const coverageCheckerPopup2MainStep2Home = document.getElementById('quiz-popup-main-step-2-home');
  const coverageCheckerPopup2MainStep3 = document.getElementById('quiz-popup-main-step-3');
  const coverageCheckerPopup2MainStep4 = document.getElementById('quiz-popup-main-step-4');
  const coverageCheckerPopup2MainStep5 = document.getElementById('quiz-popup-main-step-5');

  coverageCheckerPopup2MainStep5.style.display = 'none';
  coverageCheckerPopup2MainStep4.style.display = 'none';
  coverageCheckerPopup2MainStep3.style.display = 'flex';
  coverageCheckerPopup2MainStep2Road.style.display = 'none';
  coverageCheckerPopup2MainStep2Home.style.display = 'none';
  coverageCheckerPopup2MainStep1.style.display = 'none';

  const quizPopupBackButton = document.getElementById('quiz-popup-main-back-button');
  quizPopupBackButton.style.display = 'flex';

  quizPopupBackButton.onclick = () => {
    if (data.useLocation == 'home') {
      showCoverageCheckerPopup2MainStep2Home(data);
    } else {
      showCoverageCheckerPopup2MainStep2Road(data);
    }
  }

  const coverageCheckerPopupProgressBarStep1 = document.getElementById('quiz-popup-main-progress-bar-fill-1');
  const coverageCheckerPopupProgressBarStep2 = document.getElementById('quiz-popup-main-progress-bar-fill-2');
  const coverageCheckerPopupProgressBarStep3 = document.getElementById('quiz-popup-main-progress-bar-fill-3');
  const coverageCheckerPopupProgressBarStep4 = document.getElementById('quiz-popup-main-progress-bar-fill-4');

  coverageCheckerPopupProgressBarStep1.style.width = '100%';
  coverageCheckerPopupProgressBarStep2.style.width = '100%';
  coverageCheckerPopupProgressBarStep3.style.width = '0%';
  coverageCheckerPopupProgressBarStep4.style.width = '0%';

  const coverageCheckerPopup2MainProgressText = document.getElementById('quiz-popup-main-progress-text');
  coverageCheckerPopup2MainProgressText.innerText = 'Step 3 of 4';

  const coverageCheckerPopupMainHeading1 = document.getElementById('quiz-popup-main-heading-1');
  const coverageCheckerPopupMainHeading2 = document.getElementById('quiz-popup-main-heading-2');
  const coverageCheckerPopupMainheading3 = document.getElementById('quiz-popup-main-heading-3');
  const coverageCheckerPopupMainheading4 = document.getElementById('quiz-popup-main-heading-4');
  const coverageCheckerPopupMainheading5 = document.getElementById('quiz-popup-main-heading-5');
  const coverageCheckerPopupMainheading6 = document.getElementById('quiz-popup-main-heading-6');

  coverageCheckerPopupMainHeading1.style.display = 'none';
  coverageCheckerPopupMainHeading2.style.display = 'none';
  coverageCheckerPopupMainheading3.style.display = 'none';
  coverageCheckerPopupMainheading4.style.display = 'flex';
  coverageCheckerPopupMainheading5.style.display = 'none';
  coverageCheckerPopupMainheading6.style.display = 'none';

  const quizPopup2Main = document.getElementById('quiz-popup-main');
  quizPopup2Main.scrollTo(0, 0);

  const coverageCheckerPopup2MainStep3Submit = document.getElementById('quiz-popup-main-step-3-submit');
  const coverageCheckerPopup2MainStep3NoDiscount = document.getElementById('quiz-popup-main-step-3-continue');

  const residentialPlanCard = document.getElementById('quiz-popup-main-step-3-plan-card-residential');
  const travelPlanCard = document.getElementById('quiz-popup-main-step-3-plan-card-travel');

  if (data.useLocation == 'home') {
    residentialPlanCard.style.display = 'flex';
    travelPlanCard.style.display = 'none';
  } else {
    residentialPlanCard.style.display = 'none';
    travelPlanCard.style.display = 'flex';
  }

  const coverageCheckerPopup2MainStep3SubmitEventHandler = (e) => {
    e.preventDefault();

    data.discounted = true;

    showCoverageCheckerPopup2MainStep4(data);
  }

  const coverageCheckerPopup2MainStep3NoDiscountEventHandler = (e) => {
    e.preventDefault();

    data.discounted = false;

    showCoverageCheckerPopup2MainStep4(data);
  }

  const coverageCheckerPopup2MainStep3QualificationMessage1 = document.getElementById('quiz-popup-step-3-qualification-item-1');
  const coverageCheckerPopup2MainStep3QualificationMessage2 = document.getElementById('quiz-popup-step-3-qualification-item-2');
  const coverageCheckerPopup2MainStep3QualificationMessage3 = document.getElementById('quiz-popup-step-3-qualification-item-3');

  coverageCheckerPopup2MainStep3QualificationMessage1.addEventListener('click', coverageCheckerPopup2MainStep3SubmitEventHandler, true);
  coverageCheckerPopup2MainStep3QualificationMessage2.addEventListener('click', coverageCheckerPopup2MainStep3SubmitEventHandler, true);
  coverageCheckerPopup2MainStep3QualificationMessage3.addEventListener('click', coverageCheckerPopup2MainStep3SubmitEventHandler, true);

  coverageCheckerPopup2MainStep3NoDiscount.addEventListener('click', coverageCheckerPopup2MainStep3NoDiscountEventHandler, true);
  coverageCheckerPopup2MainStep3Submit.addEventListener('click', coverageCheckerPopup2MainStep3SubmitEventHandler, true);
  residentialPlanCard.addEventListener('click', coverageCheckerPopup2MainStep3SubmitEventHandler, true);
  travelPlanCard.addEventListener('click', coverageCheckerPopup2MainStep3SubmitEventHandler, true);
}

